<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :ignoreMaxTableItemLimit="true" :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesStoolPrResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" withCustomRowActions ref="emTable"
                                      :useCustomFieldsDefaultFlag="false"
                                      :inlineActionsDisabled="prop_inline!=='1'" :ignoreMaxTableItemLimit="true"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @linkClick="handleLinkClick"
                                      :custom-form-class="customFormClass"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #customRowActions="{row}">
                                    <b-button-group>
                                        <em-button type="gotoParentMaterial"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   @click="getParentMaterial(row)">
                                        </em-button>
                                        <em-button type="gotoChildMaterial"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   @click="getChildMaterial(row)">
                                        </em-button>
                                        <em-button type="gotoTransport" v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   @click="gotoTransport(row)">
                                        </em-button>
                                        <em-button type="edit" v-if="row.problemFlag == 1"
                                                   custom-icon="fa fa-fw fa-lg fa-question"
                                                   custom-label="查看问题"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   @click="gotoProblemPr(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                                <template #left-header>
                                    <b-button
                                        :disabled="$store.state['sithMesStoolPr'].checkedItems.length < 1"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="requiredDateMaintain()"
                                    >提醒维护需求日期
                                    </b-button>
                                    <b-button
                                        :disabled="$store.state['sithMesStoolPr'].checkedItems.length < 1"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="showHandlersDialog()"
                                    >发起问题
                                    </b-button>
                                    <b-button
                                        :disabled="$store.state['sithMesStoolPr'].checkedItems.length < 1"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="showSuppliesDialog()"
                                    >询价
                                    </b-button>
                                    <b-button
                                        variant="outline-primary"
                                        size="sm"
                                        @click="onlyShowProblemPr()"
                                    >问题PR
                                    </b-button>
                                    <b-button
                                        :disabled="$store.state['sithMesStoolPr'].checkedItems.length != 1"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="transferApply()"
                                    >发起转库申请
                                    </b-button>
                                    <b-button
                                        :disabled="$store.state['sithMesStoolPr'].checkedItems.length < 1"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="readChangeHistories"
                                    >已读需求日期变更
                                    </b-button>
                                    <mini-button :disable="$_notChecked" :loading="downloadLoading"
                                                 @btnClick="$_downloadBomDrawing">
                                        <i class="fa-solid fa-file-zipper"></i>
                                        技术文件下载
                                    </mini-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="问题PR" :visible.sync="dialogFormVisible">
            <el-form>
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="pr问题类别">
                            <el-select filterable v-model="prProblemType" placeholder="请选择">
                                <el-option v-for="item in prProblemTypes" :key="item.value" :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="处理人">
                            <el-select filterable v-model="handler" placeholder="请选择">
                                <el-option v-for="item in handlers" :key="item.value" :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="希望反馈日期">
                            <el-date-picker
                                value-format="yyyy-MM-dd HH:mm:ss"
                                v-model="hopeFeedbackDate"
                                type="datetime"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="问题描述">
                            <el-input type="textarea" :rows="2" placeholder="请输入问题描述"
                                      v-model="problemDescription"
                                      autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="附件">
                    <multi-attachment class="w-100"
                                      @idsChanged="changeAttachmentIds"
                                      :attachment-ids="attachmentIds">
                    </multi-attachment>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="initProblem">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="询价" :visible.sync="dialogAskPriceFormVisible" :z-index="1000">
            <el-form>
                <el-form-item label="请选择供应商">
                    <el-select multiple filterable v-model="vendorValue" placeholder="请选择" style="width:80%;">
                        <el-option
                            v-for="item in supplies"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="报价反馈日期">
                    <el-date-picker
                        value-format="yyyy-MM-dd HH:mm:ss"
                        v-model="expectedFeedbackDate"
                        type="datetime"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogAskPriceFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="batchAskPrice">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="确认" :visible.sync="dialogAskPriceConfirmVisible">
            <span v-if="isFixedVendor">已经指定供应商了，是否确认询价?</span>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogAskPriceConfirmVisible = false">取 消</el-button>
                <el-button type="primary"
                           @click="dialogAskPriceConfirmVisible = false ; dialogAskPriceFormVisible = true">确 定
                </el-button>
            </div>
        </el-dialog>
        <ReBModal header="需求日期操作记录"
                  large
                  ref="infoRecordList">
            <div class="d-flex flex-row mb-3" v-if="showDateFilter">
                <diverse-input :value.sync="infoRecordDateFrom" :config="infoRecordDateFromConfig" horizontal
                               class="col w-auto"></diverse-input>
                <diverse-input :value.sync="infoRecordDateEnd" :config="infoRecordDateEndConfig" horizontal
                               class="col w-auto"></diverse-input>
                <button class="btn btn-primary col-md-1" type="button" v-on:click="getInfoRecords(1)">
                    <span class="text">{{ $t("btn.basic.search") }}</span>
                </button>
            </div>

            <mini-table ref="infoRecordListResultTable"
                        read-only
                        needModelFields
                        :items="infoRecordList"
                        :fields="fields"
                        customVuexName="subview"
                        style="min-height: 350px;"
                        entity-name="sithMesPrdInfoRecord">
            </mini-table>
        </ReBModal>
        <re-b-modal ref="requireDateChangeHistory" header="需求日期操作记录"
                    hide-footer superLarge fit-content>
            <mini-table ref="requireDateChangeHistoryTable"
                        read-only
                        needModelFields
                        :items="requireDateChangeHistories"
                        customVuexName="subview"
                        style="min-height: 350px;"
                        entity-name="sithMesStoolRequireDateChangeHistory">
            </mini-table>
        </re-b-modal>
    </div>
</template>
<script>

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";

import moment from "moment";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import DiverseInput from "@/components/workflow/stuffs/DiverseInput";
import infoRecordOperationMixin from "@/mixin/em/common/stuffs/infoRecord/infoRecordOperationMixin";
import commonViewsUtil from "@/utils/commonViewsUtil";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import PageMaterialDownloadBomDrawingMixin from "@/views/sithMesII/pds/stuffs/page-material-download-bom-drawing-mixin";
import MultiAttachment from "../../../components/echarts-part/stuff/MultiAttachment.vue";


export default {
    name: "sithMesOpenPrListView",
    components: {MultiAttachment, MiniButton, ReBModal, MiniTable, DiverseInput},

    mixins: [emCommonListMixin, emCommonApiMixin, emCommonGotoMixin, infoRecordOperationMixin, PageMaterialDownloadBomDrawingMixin],

    data() {
        return {
            problemDescription: '',
            dialogFormVisible: false,
            dialogAskPriceFormVisible: false,
            dialogAskPriceConfirmVisible: false,
            showChangeHistoryModal: false,
            requireDateChangeHistories: [],
            supplies: [],
            vendorValue: [],
            priorityValue: '一般',
            prdScheduleDate: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
            queryApi: 'findOpenByFilter',
            handlers: [],
            handler: '',
            attachmentIds: '',
            prProblemTypes:[],
            prProblemType:'',
            expectedFeedbackDate: '',
            hopeFeedbackDate: '',
        }
    },
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return 'sithMesStoolPr'
        },
        isFixedVendor() {
            return this.$store.state[this.modelName].entity.fixedVendor;
        },
        $_rowMaterialKey() {
            return 'material';
        }
    },
    methods: {
        changeAttachmentIds(ids) {
            this.attachmentIds = ids;
        },
        getParentMaterial(row) {
            let url = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesStoolPr/findParentMaterialPr";
            this.$_emApiMixin_post(url, row)
                .then(response => {
                    this.$refs['emTable'].$_emCustomVuexMixin_voStore = response.data;
                })
        },
        getChildMaterial(row) {
            let url = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesStoolPr/findChildMaterialPr";
            this.$_emApiMixin_post(url, row)
                .then(response => {
                        console.log("返回的数据：" + response.data)
                        this.$refs['emTable'].$_emCustomVuexMixin_voStore = response.data;
                    }
                )
        },
        //从Open PR页面跳转到运输申请页面
        gotoTransport(row) {
            this.$_emGotoMixin_gotoHolderList(
                "sithMesInventoryTransportApplication",
                {transPrFilter: row.prNumber},
                {},
                false,
                {pathType: "list"}
            );
        },
        gotoProblemPr(row) {
            this.$router.push({name: 'sithMesStoolProblematicPrList', params: {prId: row.id}});
        },
        requiredDateMaintain() {

            let api = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesStoolPr/sendNotificationToOM";
            this.$_emApiMixin_post(api, this.$store.state[this.modelName].checkedItems)
                .then(() => {
                    this.$message.success("通知完成");
                    this.$refs.emListFilter.doQuery();
                })
        },
        initProblem() {
            this.dialogFormVisible = false;
            let rows = this.$store.state[this.modelName].rows.filter(row => this.$store.state[this.modelName].checkedItems.indexOf(row.id) !== -1);
            let row = this.$store.state[this.modelName].entity;
            let entities = [];
            rows.forEach((row) => {
                let entity = {};
                entity.prId = row.id;
                entity.prCode = row.prNumber;
                entity.prItem = row.prItemNumber;
                entity.matCode = row.material;
                entity.matDesc = row.shortText;
                entity.problemDescription = this.problemDescription;
                entity.finishFlag = 'not_finished';
                entity.engineer = this.handler;
                entity.problemPrType = this.prProblemType;
                entity.projectCode = row.projectCode;
                entity.projectName = row.projectName;
                entity.wbsNumber = row.wbsNumber;
                entity.problemReport = this.attachmentIds;
                entity.hopeFeedbackDate = moment(this.hopeFeedbackDate).format('YYYY-MM-DD HH:mm:ss');
                entities.push(entity);
            });

            let url = this.$store.state.sithMesStoolPrPrice.baseModuleUrl + "/sithMesStoolPr/batchInitProblem";
            this.$_emApiMixin_post(url, entities).then(() => {
                this.$router.push({name: 'sithMesStoolProblematicPrList'});
            });

        },
        showSuppliesDialog() {
            if (!this.isFixedVendor) {
                this.dialogAskPriceFormVisible = true;
            } else {
                this.dialogAskPriceConfirmVisible = true;
            }

            //防止选项堆叠
            if (!this.supplies.length) {
                var url = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesStoolVendor/findAllWithOutLimit";
                this.$store.dispatch("api/get", {url})
                    .then(data => {
                        console.log(data);
                        data.forEach((item) => {
                            this.supplies.push({
                                value: item['id'],
                                label: item['vendor'] + '-' + item['chName'] + '-' + item['enName']
                            });
                        });
                    });
            }
        },
        showHandlersDialog() {
            this.dialogFormVisible = true;
            this.prProblemTypes = [],
            this.handlers = [];
            var url = this.$store.state.emAclUser.baseModuleUrl + "/emAclUser/findAllWithoutVendors";
            this.$store.dispatch("api/get", {url})
                    .then(data => {
                        data.forEach((item) => {
                            this.handlers.push({
                                value: item['loginName'],
                                label: item['name'] + '-' + item['loginName']
                            });
                        });
                    });
            let uri = `${this.$_emApiMixin_entityBaseApi('emDictData')}/findByFilter`;
            this.$_emApiMixin_post(uri, {
                dictTypeFilter: 'PROBLEM_PR_TYPE'
            }).then((response) => {
                response.data.list.forEach((item) => {
                    this.prProblemTypes.push({
                        value: item['id'],
                        label: item['dictValue'] + '-' + item['dictLabel']
                    });
                });
            });
        },
        batchAskPrice() {

            //给供应商发邮件
            let entityModel = this.$store.state[this.modelName];
            const items = entityModel.rows.filter(row => entityModel.checkedItems.indexOf(row.id) !== -1);
            let entities = [];
            items.forEach((row) => {
                this.vendorValue.forEach((value, index) => {
                    let entity = {};
                    entity.prId = row.id;
                    entity.prCode = row.prNumber;
                    entity.prItem = row.prItemNumber;
                    entity.matCode = row.material;
                    entity.expectedFeedbackDate = this.expectedFeedbackDate;
                    entity.vendorId = this.vendorValue[index];
                    let vendorCode = this.supplies.filter((o) => o.value === this.vendorValue[index])[0].label.split('-')[0];
                    entity.vendor = vendorCode;
                    entities.push(entity);
                });
            });
            let url = this.$store.state.sithMesStoolPrPrice.baseModuleUrl + "/sithMesStoolPrPrice/batchAskPrice";
            this.$_emApiMixin_post(url, entities).then(() => {
                this.$router.push({name: 'sithMesStoolPrAskPriceList'});
            });
        },
        onlyShowProblemPr() {
            this.$refs.emListFilter.queryApi = 'findByOnlyProblematicPr';
            //this.MMFLoadRows('sithMesStoolOpenPr');
            this.$refs.emListFilter.doQuery();
            this.$refs.emListFilter.queryApi = 'findOpenByFilter';
        },
        transferApply() {

            let param = {'entity': 'sithMesStool26StockTransfer'};

            let row = this.$store.state[this.modelName].entity;
            let entity = {};
            entity.material = row.material;
            entity.so = row.salesDocumentNumber;
            entity.wbs = row.wbsElement;
            entity.transferQuantity = row.qtyRequested;
            entity.newProjectCode = row.projectCode;

            param.entityAux = entity;
            this.$store.dispatch('emBase/emBaseCustomSave', param)
                .then(() => {
                    commonViewsUtil.showSuccess(this, "申请提交完成！");
                });

        },
        handleLinkClick(key, row, event) {
            const prNumber = row.prNumber;
            const prItemNumber = row.prItemNumber;
            if (prItemNumber && prNumber) {
                let queryForm = {};
                queryForm.sourceFilter = 1
                queryForm.prNumberFilter = prNumber;
                queryForm.prItemNumberFilter = prItemNumber;
                this.$_emApiMixin_post(this.$_emApiMixin_moduleBaseApi("sithMesStoolRequireDateChangeHistory") + "/sithMesStoolRequireDateChangeHistory/findByFilter", queryForm)
                    .then((response) => {
                        this.requireDateChangeHistories = response.data.list
                    })
                let updateForm = {};
                updateForm.targetIds = [row.id]
                updateForm.source = 1
                this.$_emApiMixin_post(this.$_emApiMixin_moduleBaseApi("sithMesStoolRequireDateChangeHistory") + "/sithMesStoolRequireDateChangeHistory/removeUnReadChangeHistoryIds", updateForm)
                    .then(() => {
                        event.target.parentElement.parentElement.classList.remove("bg-danger")
                        this.$refs.requireDateChangeHistory.showModal()
                    })
            }
        },
        readChangeHistories() {
            const checkItems = this.$store.state[this.modelName].checkedItems
            let updateForm = {};
            updateForm.targetIds = checkItems
            updateForm.source = 1
            this.$_emApiMixin_post(this.$_emApiMixin_moduleBaseApi("sithMesStoolRequireDateChangeHistory") + "/sithMesStoolRequireDateChangeHistory/removeUnReadChangeHistoryIds", updateForm)
            this.$refs["emListFilter"].doQuery();
        },
        customFormClass: (col, row) => {
            if (col.key === 'prdScheduleDate' && row.hasUnReadRequireDateChangeHistory === true
                || col.key === 'prNumber' && row.problemFlag
                || col.key === 'category' && row.category && !row.deliverLocation
                || col.key === 'priority' && row.priority && row.priority.indexOf('紧急') > -1
                || col.key === 'supportStatus' && row.supportStatus === 0) {
                return 'bg-danger text-white';
            }
            return '';
        },
    },
    mounted() {
        let id = this.$route.params.prId;
        if (id) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', id);
        }
        this.$refs["emListFilter"].doQuery();
    }
};
</script>

<style lang="scss" scoped>
::v-deep .b-avatar.btn {
    border: 1px solid #1E5274 !important;
}
</style>
